import * as Actions from '../../actions/app'

const initialState = {
  stores: null,

  loading_crud_store: false,
  crud_store: false,

  loading_stock_in_stores_by_product: false,
  stock_in_stores_by_product: null,
}

const storesReducer = function (state = initialState, action) {
  switch (action.type) {
    case Actions.GET_STORES: {
      return {
        ...state,
        stores: action.payload,
      }
    }

    case Actions.CRUD_STORE: {
      return {
        ...state,
        loading_crud_store: action.payload.loading,
        crud_store: action.payload.crud,
      }
    }

    case Actions.GET_STOCK_IN_STORES_BY_PRODUCT_ID: {
      return {
        ...state,
        loading_stock_in_stores_by_product: action.payload.loading,
        stock_in_stores_by_product: action.payload.data ?? state.stock_in_stores_by_product,
      }
    }

    default: {
      return state
    }
  }
}

export default storesReducer
